(function() { window.GUID_b3393081_0d18_4e15_a0a2_e974292b8b58 = { getGuid: function() { return "b3393081-0d18-4e15-a0a2-e974292b8b58"; } }; })();
var CrossTable;
(function (CrossTable) {
    var desktop;
    (function (desktop) {
        var lastRow = null;
        var lastCell = null;
        var lastHighlightedCells = null;
        var btnEditRRBSchedule = $('#BtnEditRRBSchedule');
        var btnScoreSheet = $('#BtnScoreSheet');
        var btnAddEntity = $('#BtnAddEntity');
        var saveButtonIsVisible = false;
        var isEditable = false;
        var canChangeScores = false;
        var opponentRows = null;
        btnAddEntity.on('click', 'a', function (e) {
            e.preventDefault();
            if (actualFlowBlockId != null && actualFlowBlockId != "" && actualFlowBlockId != "0") {
                var data = {
                    flowBlockId: actualFlowBlockId
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "AddEntity",
                    Url: CSParameters.RUrl + 'FlowBlockRRBs/AddEntity/' + CSParameters.SportEventId,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                });
                popup.OnContentLoaded = function () {
                    $('.CSDropDownCheckboxes').CSDropDownCheckboxes();
                };
                popup.OnPosted = function (result) {
                    if (result != '') {
                        alert(result);
                    }
                    else {
                        var data = {};
                        data.flowBlockId = actualFlowBlockId;
                        data.highlightedEntityBaseId = null;
                        data.highlightedDrawPosition = null;
                        CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/Chart/" + CSParameters.SportEventId, data, function (queryResult) {
                            UpdateChart(queryResult, true);
                        });
                    }
                };
            }
        });
        btnEditRRBSchedule.on('click', 'a', function (e) {
            e.preventDefault();
            if (actualFlowBlockId != null && actualFlowBlockId != "" && actualFlowBlockId != "0" && lastCell != null) {
                var encrid = lastCell.data('encrid');
                var data = {
                    flowBlockId: actualFlowBlockId,
                    encounterRowId: encrid
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: 'GetEncounterPopup',
                    Url: CSParameters.RUrl + 'Schedules/EditSchedulesFromCrossTable/' + CSParameters.SportEventId,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                });
                popup.OnPosted = function (result) {
                    btnEditRRBSchedule.addClass('IsDisabled');
                    UpdateChart(result, true);
                };
            }
        });
        function BindBtnScoreSheet_click() {
            btnScoreSheet.off('click.crossTableScoreSheet', 'a').on('click.crossTableScoreSheet', 'a', function (e) {
                e.preventDefault();
                if (actualFlowBlockId != null && actualFlowBlockId != "" && actualFlowBlockId != "0" && lastCell != null) {
                    var encrid = parseInt(lastCell.attr('data-encrid'), 10);
                    if (isNaN(encrid) || encrid <= 0) {
                        return;
                    }
                    var data = {
                        flowBlockId: actualFlowBlockId,
                        encounterRowId: encrid,
                        elementToRefresh: 'chart'
                    };
                    CompuSport.Ajax.Get(CSParameters.RUrl + 'Scores/CheckIsNewScoreSheet/' + CSParameters.SportEventId, data, function (response) {
                        if (response.isNewScoreSheet) {
                            var popup = new CompuSport.Controls.Popup();
                            popup.GetAndShow({
                                PopupId: "ScorePopup",
                                Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                                Data: data,
                                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                            });
                            popup.OnPosted = function (result) {
                                btnScoreSheet.addClass('IsDisabled');
                                UpdateChart(result, true);
                            };
                            popup.OnClosed = function () {
                                if ($('#GridViewSchedules').length > 0) {
                                    $('#TxtMasterSearchAutoComplete').focus();
                                }
                            };
                        }
                    });
                }
            });
        }
        function BindCrossTableEvents(canvasContentEdge) {
            lastCell = null;
            saveButtonIsVisible = false;
            opponentRows = null;
            isEditable = canvasContentEdge.find("table.IsEditable").length > 0;
            canChangeScores = canvasContentEdge.find("table.CanChangeScores").length > 0;
            opponentRows = $('.OpponentRow', canvasContentEdge);
            opponentRows.on('mouseup', function (e) {
                var clickedRow = $(this);
                opponentRows.removeClass('Highlighted');
                clickedRow.addClass('Highlighted');
                lastRow = clickedRow;
                var entityBaseId = clickedRow[0].id;
                GetEntityPopup(entityBaseId, null, false, function (encounterInfos) {
                    actualEncounterInfos = encounterInfos;
                });
            }).on('mouseup', '.IsEnc', function () {
                var scCell = $(this);
                if (isEditable) {
                    MakeCellEditable(scCell, canvasContentEdge, canChangeScores);
                    btnEditRRBSchedule.removeClass('IsDisabled');
                    btnScoreSheet.removeClass('IsDisabled');
                }
                else {
                    HighlightActualCellAndOpponentCell(scCell);
                    btnEditRRBSchedule.addClass('IsDisabled');
                    btnScoreSheet.addClass('IsDisabled');
                }
            });
            BindBtnScoreSheet_click();
        }
        desktop.BindCrossTableEvents = BindCrossTableEvents;
        function UnbindCrossTableEvents() {
            lastCell = null;
            btnScoreSheet.off('click.crossTableScoreSheet', 'a');
        }
        desktop.UnbindCrossTableEvents = UnbindCrossTableEvents;
        function HighlightActualCellAndOpponentCell(cell) {
            if (lastHighlightedCells != null) {
                lastHighlightedCells.removeClass('OppSelect');
            }
            var rrbnum = cell.data('rrbnum');
            var rrboppnum = cell.data('rrboppnum');
            var cellsToHighlight = null;
            if (typeof (rrboppnum) === 'undefined') {
                var encrid = cell.data('encrid');
                cellsToHighlight = $("[data-encrid=" + encrid + "]", opponentRows);
            }
            else {
                cellsToHighlight = $("[data-rrboppnum=" + rrbnum + "][data-rrbnum=" + rrboppnum + "]", opponentRows);
            }
            if (typeof (cellsToHighlight) != 'undefined') {
                cellsToHighlight.addClass('OppSelect');
            }
            lastHighlightedCells = cellsToHighlight;
        }
        function MakeCellEditable(cell, canvasContentEdge, canChangeScores) {
            if (cell.find('input').length > 0 || cell.hasClass('NoGame') || isEditable == false) {
                return;
            }
            HighlightActualCellAndOpponentCell(cell);
            ApplyLastCellInputToContent(canvasContentEdge);
            var encrid = parseInt(cell.attr('data-encrid'), 10);
            if (isNaN(encrid) || encrid <= 0) {
                return;
            }
            lastCell = cell;
            var rrboppnum = cell.data('rrboppnum');
            var innerDiv = cell.find('div');
            var innerValue = cell.data('score');
            if (canChangeScores == true) {
                cell.data('lastval', innerDiv.html());
                var input = $("<input class='CrossTableValue' type='number' data-encrid='" + encrid + "' value='" + innerValue + "' />");
                innerDiv.html(input);
                input.focus();
                input.select();
                input.on('blur', function () {
                    ApplyLastCellInputToContent(canvasContentEdge);
                }).on('keydown', function (e) {
                    if (e.keyCode == 13) {
                        e.preventDefault();
                        ApplyLastCellInputToContent(canvasContentEdge);
                    }
                    else if (e.keyCode == 9 /*TAB*/) {
                        e.preventDefault();
                        ApplyLastCellInputToContent(canvasContentEdge);
                        var nextCell = cell.nextAll('.IsEnc').first();
                        if (nextCell.length == 0) {
                            nextCell = $(cell.parent().next().find('.IsEnc')[0]);
                        }
                        if (nextCell.length == 0) {
                            nextCell = $('.IsEnc', canvasContentEdge).first();
                        }
                        MakeCellEditable(nextCell, canvasContentEdge, canChangeScores);
                    }
                });
            }
        }
        function ApplyLastCellInputToContent(canvasContentEdge) {
            if (lastCell == null) {
                return;
            }
            var innerDiv = lastCell.find('div');
            var input = lastCell.find('input');
            if (input.length > 0) {
                var lastVal = lastCell.data('lastval');
                var lastValDiv = $('<div>' + lastVal + '</div>');
                var lastValScore = lastValDiv.find('.Sc').html();
                var inputVal = input.val();
                if (lastValScore != inputVal) {
                    lastValDiv.find('.Sc').html(inputVal);
                    innerDiv.html(lastValDiv.html());
                    lastCell.addClass('HasChanged');
                    if (!saveButtonIsVisible) {
                        BindSaveButton(canvasContentEdge);
                        saveButtonIsVisible = true;
                    }
                }
                else {
                    innerDiv.html(lastVal);
                }
            }
        }
        function BindSaveButton(canvasContentEdge) {
            var button = canvasContentEdge.find('.RRBNumberHeader img');
            button.slideDown(function () {
                button.Blink(10, { css: { backgroundColor: '#0000ff', opacity: 0.25 }, duration: 500 }, { css: { backgroundColor: '#fff', opacity: 1 }, duration: 500 });
                button.on('click', function () {
                    var crossTableValues = canvasContentEdge.find('.HasChanged');
                    var datas = [];
                    $.each(crossTableValues, function () {
                        var cell = $(this);
                        var encrid = cell.data('encrid');
                        var entityBaseId = cell.closest('tr')[0].id;
                        var innerDiv = cell.find('div');
                        var item = {
                            EncounterRowId: encrid,
                            EntityBaseId: entityBaseId,
                            Value: innerDiv.find('.Sc').html()
                        };
                        datas.push(item);
                    });
                    var data = {
                        flowBlockId: canvasContentEdge.data('flowblockid'),
                        values: JSON.stringify(datas)
                    };
                    CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/SaveCrossTable/" + CSParameters.SportEventId, data, function (queryResult) {
                        UpdateChart(queryResult, true);
                    });
                });
            });
        }
    })(desktop = CrossTable.desktop || (CrossTable.desktop = {}));
})(CrossTable || (CrossTable = {}));

//# sourceMappingURL=CrossTable.desktop.js.map
